import { EventObject } from "./eventObject";
import { Interpreter /*, State*/ } from "./js-interpreter";
export class Runner {
    constructor() {
        this._interpreter = new Interpreter("", null);
        this._isPaused = false;
        this._stepped = new EventObject(); //The code has advanced
        //paused:EventObject = new EventObject();       //Something paused the runner: Breakpoint or user pause.
        this._exceptioned = new EventObject(); //Unhandled exception, program ended.
        this._terminated = new EventObject(); //Program completed without exception
        this._stepMilliseconds = 0;
    }
    get error() { return this._error; }
    get steppedEventObject() { return this._stepped; }
    get exceptionedEventObject() { return this._exceptioned; }
    get terminatedEventObject() { return this._terminated; }
    set stepMilliseconds(value) {
        this._stepMilliseconds = value;
    }
    attach(interpreter) {
        this._interpreter = interpreter;
        this.startFutureStep();
    }
    detach() {
        this.stopFutureStep();
    }
    pause() {
        this._isPaused = true;
    }
    unpause() {
        this._isPaused = false;
    }
    step() {
        if (this._isPaused) {
            return;
        }
        let isRunning = true;
        try {
            isRunning = this._interpreter.step();
            /*const stateStack:Array<State> = this._interpreter.getStateStack();
            const state:State = stateStack[stateStack.length - 1];
            console.log(state.node);*/
            this._stepped.raise();
            if (!isRunning) {
                this.stopFutureStep();
                this._terminated.raise();
            }
        }
        catch (error) {
            this._error = error;
            this.stopFutureStep();
            this._exceptioned.raise();
        }
    }
    startFutureStep() {
        //this.stopFutureStep();
        this._futureID = window.setInterval(() => { this.step(); }, this._stepMilliseconds);
    }
    stopFutureStep() {
        if (this._futureID) {
            window.clearInterval(this._futureID);
            this._futureID = undefined;
        }
    }
}
